export default __webpack_public_path__ + "static/media/bell 1.4cef014f.svg";